export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="border-t border-[#D4AF37]/20 py-6"
        >
            <p
                data-testid="footer-text"
                className="px-4 text-center text-sm text-[#B5B5B5]"
            >
                © 2026 Virat WorkHub | Instagram Reel Uploading Work
            </p>
        </footer>
    );
}
